import * as React from 'react';

const FileAdd = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 12 12"
			width="1em"
			height="1em"
			{...props}
		>
			<g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
				<path
					d="M10.714 10.714a.857.857 0 01-.857.857H2.143a.857.857 0 01-.857-.857V1.286a.857.857 0 01.857-.857h4.286l4.285 4.285zM5.571 4.929v3M4.071 6.429h3"
					strokeWidth={0.85714}
				/>
			</g>
		</svg>
	);
};

export default FileAdd;
